'use strict'

import React from 'react'
import $     from 'jquery'

export default class ButtonPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  labelClick (name) {
    this.setState({
      [name]: this.refs[name].checked
    })
  }

  resizeButtons () {
    let highest = 0
    let highestEl = null

    $('.flow-form2 label.button').each(function (i) {
      if ($(this).height() > highest) {
        highest = $(this).height()
        highestEl = this
      }
    })

    $('.flow-form2 label.button').not(highestEl).height(highest)
  }

  componentDidMount () {
    setTimeout(this.resizeButtons, 1)

    $(window).on('resize', this.resizeButtons)
  }

  componentWillUnmount () {
    $(window).off('resize', this.resizeButtons)
  }

  render () {
    const { buttons, onClick, reference } = this.props

    return (
      <div className='button-page'>
        {buttons.map((button, i) => {
          let displayName = (reference) ? button[reference] : button

          return (
            <label
              key={displayName}
              onClick={this.labelClick.bind(this, displayName)}
              className={`button${this.state[displayName] ? ' active' : ''}`}
              >
              <input
                type='checkbox'
                ref={displayName}
                name={displayName}
                key={i}
                onClick={onClick}
                data-option={displayName}
                />
              <span>{displayName}</span>
            </label>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/button-page.js